export default __webpack_public_path__ + "static/media/art.54bdd382.jpg";